(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gdgc-mega-menu-list"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.gdgcLocationPromosInitialised) return;
    window.gdgcLocationPromosInitialised = true;
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const locationPromos = {
      'wigan garden centre': {
        heading: 'Wigan Garden Centre',
        cta: 'More Information',
        image: 'https://res.cloudinary.com/dwhoqzh7b/image/upload/v1709904963/gdgc_wigan.png'
      },
      'cheadle garden centre': {
        heading: 'Cheadle Garden Centre',
        cta: 'More Information',
        image: 'https://res.cloudinary.com/dwhoqzh7b/image/upload/v1709906322/XjsMcItE.jpg'
      }
    };

    const normalise = (value) =>
      (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

    const createPromo = (data, href) => {
      const link = document.createElement('a');
      link.className = 'gdgc-mobile-location-promo';
      link.href = href || '#';
      link.setAttribute('data-gdgc-mobile-location-promo', data.heading);

      link.innerHTML = `
        <img
          class="gdgc-mobile-location-promo__image"
          src="${data.image}"
          alt="${data.heading}"
          width="720"
          height="420"
          loading="lazy"
        >
        <span class="gdgc-mobile-location-promo__content">
          <strong class="gdgc-mobile-location-promo__heading">
            ${data.heading}
          </strong>
          <span class="gdgc-mobile-location-promo__cta">
            ${data.cta}
            <svg viewBox="0 0 18 18" aria-hidden="true" focusable="false">
              <path
                d="M4 9h9M10 5l4 4-4 4"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </span>
      `;

      return link;
    };

    const addMobileLocationPromos = () => {
      if (!mobileQuery.matches) return;

      document
        .querySelectorAll(
          '.menu-drawer .menu-drawer__menu-item--mainlist, ' +
          '.menu-drawer a[href], .menu-drawer button'
        )
        .forEach((trigger) => {
          const key = normalise(trigger.textContent);
          const data = locationPromos[key];

          if (!data) return;

          const item =
            trigger.closest('details') ||
            trigger.closest('.menu-drawer__list-item') ||
            trigger.closest('li');

          if (!item) return;

          const submenu =
            item.querySelector('.menu-drawer__submenu') ||
            item.querySelector('[data-menu-drawer-submenu]') ||
            item.querySelector('.menu-drawer__menu-container');

          if (!submenu) return;

          if (
            submenu.querySelector(
              `[data-gdgc-mobile-location-promo="${data.heading}"]`
            )
          ) {
            return;
          }

          const destination =
            submenu.querySelector('.menu-drawer__featured-content-list') ||
            submenu.querySelector('.menu-drawer__featured-content') ||
            submenu.querySelector('.menu-drawer__menu') ||
            submenu;

          const handle = key.replace(/\s+/g, '-');
          const desktopPromoLink = document.querySelector(
            `.gdgc-mega-menu[data-gdgc-mega-menu="${handle}"] ` +
            '.gdgc-mega-menu__promo-link'
          );
          const href =
            trigger.getAttribute('href') ||
            desktopPromoLink?.getAttribute('href') ||
            '#';

          destination.appendChild(createPromo(data, href));
        });
    };

    const initialise = () => {
      let frame = 0;
      let observer;

      const schedule = () => {
        if (!mobileQuery.matches || frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          addMobileLocationPromos();
        });
      };

      const sync = () => {
        observer?.disconnect();
        cancelAnimationFrame(frame);
        frame = 0;
        if (!mobileQuery.matches) return;
        addMobileLocationPromos();
        const header = document.getElementById('header-component');
        if (header) {
          observer ||= new MutationObserver(schedule);
          observer.observe(header, { childList: true, subtree: true });
        }
      };

      sync();
      mobileQuery.addEventListener('change', sync);
      document.addEventListener('shopify:section:load', sync);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }
  })();

if (!customElements.get('gdgc-furniture-filters')) {
  customElements.define('gdgc-furniture-filters', class extends HTMLElement {
    static requests = new Map();
    connectedCallback() {
      // Keep server-rendered menu options untouched on collection pages.
      // Collection facet updates can already change the page DOM; observing
      // and repeatedly repainting this menu caused avoidable flicker.
      this.menuItem = this.closest('.menu-list__list-item');
      this.onOpen ||= () => {
        if (!this.loaded || !this.usable(this.currentContent())) this.load();
      };
      this.menuItem?.addEventListener('pointerenter', this.onOpen);
      this.menuItem?.addEventListener('focusin', this.onOpen);

      const content = this.currentContent();
      if (this.dataset.serverReady === 'true' && this.usable(content)) {
        // The unfiltered collection already supplied valid options.
        // No network request or DOM replacement needed.
        this.remember(content);
        return;
      }
      if (this.restoreCache()) return;
      this.load();
    }

    disconnectedCallback() {
      this.menuItem?.removeEventListener('pointerenter', this.onOpen);
      this.menuItem?.removeEventListener('focusin', this.onOpen);
      clearTimeout(this.retryTimer);
    }

    stableOptionsIntact() {
      return this.loaded && this.stableContent?.parentElement === this &&
        this.childElementCount === 1 && this.stableContent.childElementCount === this.stableChildCount &&
        this.stableLists?.length === 2 && this.stableLists.every((list) => list.isConnected && list.childElementCount > 0);
    }

    currentContent() {
      const blocks = this.querySelectorAll('[data-gdgc-fm-filter-content]');
      return blocks.length === 1 ? blocks[0] : null;
    }

    usable(content) {
      if (!content || content.dataset.collectionHandle !== this.dataset.collectionHandle || content.querySelector('[data-gdgc-fm-loading]')) return false;
      const lists = Array.from(content.querySelectorAll('.gdgc-fm__values'));
      return lists.length === 2 && lists.every((list) => list.querySelector('a.gdgc-fm__option[href]'));
    }

    cacheKey() {
      if (!this.dataset.collectionUrl) return null;
      const stamp = [this.dataset.collectionUrl, this.dataset.sectionId, this.dataset.cacheContext || document.documentElement.lang, window.location.search].join('|');
      if (stamp === this.keyStamp) return this.memoKey;
      try {
        const url = new URL(this.dataset.collectionUrl, window.location.origin);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id') || '';
        this.keyStamp = stamp;
        this.memoKey = ['gdgc-furniture-options-v3', url.origin, url.pathname, this.dataset.sectionId, this.dataset.cacheContext || document.documentElement.lang, preview].join('|');
        return this.memoKey;
      } catch (error) { return null; }
    }

    remember(content) {
      if (!this.usable(content)) return false;
      const html = content.outerHTML;
      const key = this.cacheKey();
      const changed = html !== this.lastGoodHTML || key !== this.lastGoodKey;
      this.lastGoodHTML = html;
      this.lastGoodKey = key;
      this.stableContent = content;
      this.stableChildCount = content.childElementCount;
      this.stableLists = Array.from(content.querySelectorAll('.gdgc-fm__values'));
      this.loaded = true;
      this.dataset.serverReady = 'true';
      if (changed) this.saveCache();
      return true;
    }

    paint(content) {
      if (!this.usable(content)) return false;
      this.replaceChildren(document.importNode(content, true));
      return this.remember(this.currentContent());
    }

    preserveOptions() {
      if (this.stableOptionsIntact()) return true;
      if (!this.lastGoodHTML || this.lastGoodKey !== this.cacheKey()) return false;
      const current = this.currentContent();
      if (this.usable(current) && !this.querySelector('[data-gdgc-fm-loading]')) {
        this.loaded = true;
        return true;
      }
      const doc = new DOMParser().parseFromString(this.lastGoodHTML, 'text/html');
      return this.paint(doc.querySelector('[data-gdgc-fm-filter-content]'));
    }

    saveCache() {
      const key = this.cacheKey();
      if (!key || !this.lastGoodHTML || this.lastGoodKey !== key) return;
      try {
        sessionStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), html: this.lastGoodHTML }));
      } catch (error) {}
    }

    restoreCache() {
      const key = this.cacheKey();
      if (!key) return false;
      try {
        const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (!cached || typeof cached.html !== 'string') return false;
        const age = Date.now() - cached.savedAt;
        if (!Number.isFinite(age) || age < 0 || age > 30 * 60 * 1000) return false;
        const doc = new DOMParser().parseFromString(cached.html, 'text/html');
        return this.paint(doc.querySelector('[data-gdgc-fm-filter-content]'));
      } catch (error) { return false; }
    }

    applyFetchedOptions(content) {
      this.fetchedOptions = content;
      if (this.contains(document.activeElement)) {
        this.addEventListener('focusout', () => queueMicrotask(() => this.load()), { once: true });
        return;
      }
      this.paint(content);
      this.fetchedOptions = null;
    }

    requestOptions(sectionId) {
      const url = new URL(this.dataset.collectionUrl, window.location.origin);
      if (url.origin !== window.location.origin) return Promise.reject(new Error('Invalid collection'));
      url.search = '';
      url.hash = '';
      url.searchParams.set('section_id', sectionId);
      const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      const requests = this.constructor.requests;
      const key = url.href;
      if (requests.has(key)) return requests.get(key);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      const task = fetch(url, { credentials: 'same-origin', cache: 'default', signal: controller.signal })
        .then(async (response) => {
          if (!response.ok) throw new Error('Filter request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const host = Array.from(doc.querySelectorAll('gdgc-furniture-filters')).find((element) => element.dataset.collectionHandle === this.dataset.collectionHandle);
          const content = host?.querySelector('[data-gdgc-fm-filter-content]');
          if (!this.usable(content) || host.dataset.serverReady !== 'true') throw new Error('Filter content unavailable');
          return content;
        })
        .finally(() => { clearTimeout(timeout); requests.delete(key); });
      requests.set(key, task);
      return task;
    }

    async load() {
      const current = this.currentContent();
      if (this.dataset.serverReady === 'true' && this.usable(current)) {
        this.remember(current);
        return;
      }
      if (this.preserveOptions()) return;
      if (this.restoreCache()) return;
      if (this.usable(this.fetchedOptions)) { this.applyFetchedOptions(this.fetchedOptions); return; }
      if (this.pending || !this.dataset.collectionUrl || !this.dataset.sectionId) return;
      this.pending = true;
      this.attempts = (this.attempts || 0) + 1;
      this.setAttribute('aria-busy', 'true');
      const requestedKey = this.cacheKey();

      try {
        let content;
        const filterSection = this.dataset.filterSectionId;
        try {
          content = await this.requestOptions(filterSection || this.dataset.sectionId);
        } catch (error) {
          // Existing header remains a fallback while the lightweight section is installed.
          if (!filterSection || filterSection === this.dataset.sectionId) throw error;
          if (!this.isConnected) return;
          content = await this.requestOptions(this.dataset.sectionId);
        }
        if (!this.isConnected || requestedKey !== this.cacheKey()) return;
        if (this.preserveOptions()) return;
        this.applyFetchedOptions(content);
      } catch (error) {
        if (!this.isConnected || this.preserveOptions() || this.restoreCache()) return;
        const status = this.querySelector('[data-gdgc-fm-status]');
        if (this.attempts < 2) {
          this.retryTimer = setTimeout(() => this.load(), 1000);
        } else {
          this.querySelectorAll('[data-gdgc-fm-loading]').forEach((element) => element.remove());
          if (status) {
            status.hidden = false;
            status.textContent = 'Options could not load. Please use View all to browse the furniture collection.';
          }
        }
      } finally {
        this.pending = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gdgc-mobile-furniture-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gdgc-mobile-furniture-tabs')) {
    customElements.define(
      'gdgc-mobile-furniture-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.activeFilter ||= '';
          this.media ||= window.matchMedia('screen');

          this.onClick ||= (event) => {
            const button = event.target.closest('[data-gdgc-filter]');

            if (!button || !this.contains(button)) return;

            const filter = button.dataset.gdgcFilter;

            this.select(
              this.activeFilter === filter ? '' : filter
            );
          };

          this.onKeyUp ||= (event) => {
            if (event.key !== 'Escape' || !this.activeFilter) return;

            event.preventDefault();
            event.stopPropagation();

            const previous = this.activeFilter;

            this.select('');

            this.querySelector(
              `[data-gdgc-filter="${previous}"]`
            )?.focus();
          };

          this.onToggle ||= () => {
            if (!this.menuDetails?.open) this.select('');
          };

          this.schedule ||= () => {
            if (this.frame) return;

            this.frame = requestAnimationFrame(() => {
              this.frame = 0;

              if (this.isConnected) this.sync();
            });
          };

          this.onMediaChange ||= () => {
            this.observer.disconnect();

            if (this.media.matches) {
              this.observer.observe(this, {
                childList: true,
                subtree: true
              });
            }

            this.schedule();
          };

          this.observer ||= new MutationObserver(this.schedule);
          this.menuDetails = this.closest('details');

          this.addEventListener('click', this.onClick);
          this.addEventListener('keyup', this.onKeyUp);

          this.menuDetails?.addEventListener(
            'toggle',
            this.onToggle
          );

          this.media.addEventListener(
            'change',
            this.onMediaChange
          );

          this.onMediaChange();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keyup', this.onKeyUp);

          this.menuDetails?.removeEventListener(
            'toggle',
            this.onToggle
          );

          this.media?.removeEventListener(
            'change',
            this.onMediaChange
          );

          this.observer?.disconnect();

          cancelAnimationFrame(this.frame);

          this.frame = 0;
        }

        hideDuplicateHeadings(host) {
          // Match the repeated labels from gdgc-mega-menu-list without
          // depending on that snippet's heading classes.
          const labels = new Set([
            'shop by number of seats',
            'shop by colour'
          ]);
          const normalize = (text) =>
            text.replace(/\s+/g, ' ').trim().toLowerCase();
          const walker = document.createTreeWalker(
            host,
            NodeFilter.SHOW_TEXT
          );
          const headings = new Set();

          while (walker.nextNode()) {
            const text = walker.currentNode;
            if (!labels.has(normalize(text.textContent))) continue;

            let heading = text.parentElement;
            if (!heading || heading.closest(
              'a, button, summary, label, [role="button"], .gdgc-fm__values'
            )) continue;

            // Include decorative wrappers, but preserve all filter controls.
            while (
              heading.parentElement &&
              heading.parentElement !== host &&
              labels.has(normalize(heading.parentElement.textContent)) &&
              !heading.parentElement.querySelector(
                'a, button, input, select, textarea, summary, .gdgc-fm__values'
              )
            ) {
              heading = heading.parentElement;
            }

            if (
              heading !== host &&
              labels.has(normalize(heading.textContent)) &&
              !heading.querySelector(
                'a, button, input, select, textarea, summary, .gdgc-fm__values'
              )
            ) {
              headings.add(heading);
            }
          }

          headings.forEach((heading) => {
            heading.setAttribute('data-gdgc-duplicate-heading', '');
          });
        }

        select(filter) {
          this.activeFilter =
            filter === 'seats' || filter === 'colour'
              ? filter
              : '';

          this.sync();
        }

        sync() {
          const tabs = this.querySelector(
            '[data-gdgc-mobile-tabs]'
          );

          const slot = this.querySelector(
            '[data-gdgc-mobile-filter-slot]'
          );

          const host = this.querySelector(
            'gdgc-furniture-filters'
          );

          const categories = this.querySelector(
            '.gdgc-fm__categories'
          );

          if (!tabs || !slot) return;

          if (!this.media.matches) {
            tabs.hidden = true;
            slot.hidden = true;

            if (categories) categories.hidden = false;

            const layout = this.querySelector(
              '.gdgc-fm__layout'
            );

            if (
              host &&
              layout &&
              host.parentElement === slot
            ) {
              layout.append(host);
            }

            return;
          }

          if (!host) {
            tabs.hidden = true;
            slot.hidden = true;
            return;
          }

          if (host.parentElement !== slot) {
            slot.append(host);
          }

          this.hideDuplicateHeadings(host);

          tabs.hidden = false;
          this.dataset.activeFilter = this.activeFilter;

          if (categories) {
            categories.id = this.dataset.categoryId;
            categories.hidden = Boolean(this.activeFilter);
          }

          slot.hidden = !this.activeFilter;

          const buttons = tabs.querySelectorAll(
            '[data-gdgc-filter]'
          );

          buttons.forEach((button) => {
            const selected =
              button.dataset.gdgcFilter === 'category'
                ? !this.activeFilter
                : button.dataset.gdgcFilter === this.activeFilter;

            button.setAttribute(
              'aria-expanded',
              String(selected)
            );

            if (selected) {
              slot.setAttribute(
                'aria-labelledby',
                button.id
              );
            }
          });

          if (!this.activeFilter) {
            slot.removeAttribute('aria-labelledby');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
